import React from 'react';
import '../../Styles/Testimonial.css';
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Testimonial = () => {
  const settings12 = {
    dots: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 6000,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <section className="bd-testimonial-area gray-bg pt-100 pb-50">
      <div className="container" style={{ maxWidth: "1300px" }}>
        <div className="row media_test">
          <div className="col-xl-8 media_testimonial">
            <div className="bd-testimonial testimonial-text mb-50">
              <Slider {...settings12}>
                <div className="testimonial-slide">
                  <div className="bd-testimonial-item text-center">
                    <div className="bd-testimonial-icon mb-45">
                      <i className="fas fa-quote-left"></i>
                    </div>
                    <p className="mb-20">
                    When I first searched for a marketing company, I had no idea what I really needed—until I met the Zithas team. They offered everything under one roof, from franchise planning to digital marketing. We started with 12 stores, and now we’re at 20 with more on the way. Their team is always responsive, no matter the time zone. I’m truly grateful and would 100% recommend Zithas to any business looking to grow.
                    </p>
                    <div className="home-testimonial-content">
        
                      <div className="testimonial-author">
                        <h3 className="bd-testimonial-title">Rejo Johnson</h3>
                        <span className="testimonial-name pb-20">Managing Director, Rollz Ice Cream</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="testimonial-slide">
                  <div className="bd-testimonial-item text-center">
                    <div className="bd-testimonial-icon mb-45">
                      <i className="fas fa-quote-left"></i>
                    </div>
                    <p className="mb-20">
                      We knew what we wanted, and Zithas made it happen step by step. Their team was not only skilled but easy to work with, and genuinely cared about getting things right. Our website now runs smoother than ever, bookings are up, and everything just feels easier. More than a service provider, they’ve been a true partner we can rely on.!
                    </p>
                    <div className="home-testimonial-content">
        
                      <div className="testimonial-author">
                        <h3 className="bd-testimonial-title">Ameer Munir</h3>
                        <span className="testimonial-name pb-20">Founder Air Dynamic Solutions</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="testimonial-slide">
                  <div className="bd-testimonial-item text-center">
                    <div className="bd-testimonial-icon mb-45">
                      <i className="fas fa-quote-left"></i>
                    </div>
                    <p className="mb-20">
                      As the last U.S. maker of warp equipment, we take pride in what we do—and Zithas matched that pride with real innovation. Our new React site is sleek, fast, and easy to run. The custom admin panel puts us in full control, and inquiries have taken off. We’re genuinely thrilled.
                    </p>
                    <div className="home-testimonial-content">
                      <div className="testimonial-author">
                        <h3 className="bd-testimonial-title">Kevin Ahlstrom</h3>
                        <span className="testimonial-name pb-20">Founder Mc-Coy USA</span>
                      </div>
                    </div>
                  </div>
                </div>
              </Slider>
            </div>
          </div>

          <div className="col-xl-8 pl-20 second_width_test">
            <div className="testimonial_video pt-20 pl-40">
              <iframe
                src="https://www.youtube-nocookie.com/embed/EyE6_8Uklpg?autoplay=0&rel=0"
                className="resp-videos"
                allowFullScreen
                frameBorder="0"
                width="535"
                height="300"
                title="Everytime You Go Away - Paul Young"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonial;
